import React from 'react'
import PropTypes from 'prop-types'

class DelayComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = { isRendered: props.delay === 0 }
  }

  componentDidMount() {
    const { isRendered } = this.state
    if (isRendered) {
      return
    }

    const { delay } = this.props

    setTimeout(() => {
      this.setState({ isRendered: true })
    }, delay)
  }

  render() {
    const { children } = this.props
    const { isRendered } = this.state

    return isRendered ? children : null
  }
}

DelayComponent.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
}

DelayComponent.defaultProps = {
  children: null,
  delay: 0,
}

export default DelayComponent
